import cookie from "js-cookie";

export const setCookie = (key, value) => {
  cookie.set(key, value, {
    // expires: 1,
    path: "/",
  });
};

export const removeCookie = (key) => {
  cookie.remove(key);
};

export const getCookie = (key, req) => {
  let token = cookie.get(key);
  return token;
};

// set remember me login data
export const setLoginData = (data) => {
  setCookie("ww:log", btoa(JSON.stringify(data)));
};

// get remember me login data
export const getLoginData = () => {
  try {
    const data = getCookie("ww:log")?.toString();
    const logData = JSON.parse(atob(data));
    return logData;
  } catch (e) {
    return undefined;
  }
};

// clear remember me login data
export const clearLoginData = () => {
  removeCookie("ww:log");
};

export const forceLogout = () => {
  removeCookie("freemans-token");
  removeCookie("fsoId");
  removeCookie("userData");
  removeCookie("isLogin");
  removeCookie("instanceUrl");
  window.location.href = "/login";
  window.location.reload(true);
};
